import { useState, useEffect } from "react";

export default function useGeolocation() {
  const [position, setPosition] = useState(null); // { lat, lng }
  const [error, setError] = useState(null); // "unsupported" | "denied" | "unavailable"
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!("geolocation" in navigator)) {
      setError("unsupported");
      setLoading(false);
      return;
    }

    // One-shot lookup — consumers only need a fixed point to sort/center
    // against, not continuous tracking.
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setPosition({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        setError(null);
        setLoading(false);
      },
      (err) => {
        setError(err.code === err.PERMISSION_DENIED ? "denied" : "unavailable");
        setLoading(false);
      },
      { enableHighAccuracy: true, maximumAge: 30000, timeout: 10000 },
    );
  }, []);

  return { position, error, loading };
}
